import { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { VStack, HStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import LoaderIndicator from "../components/loader_indicator";

import FiltersGrid from "../components/filters_grid";
import TableData from "../components/open_profit_page/table_data";

const OpenProfitPage = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.getAllPaysOrgs();
    pageStore.getAllManagers();
    pageStore.getAllDepartments();
    pageStore.getAllBackups();
    pageStore.resetFilters();
  }, []);

  useEffect(() => {
    pageStore.updateSelectedView("manager-lite");
    pageStore.updateSelectedPeriod("");
  }, []);

  useEffect(() => {
    pageStore.updateSelectedPage("/openProfit");
  }, []);

  console.log("email", pageStore.email);

  return (
    <VStack width={"100%"} align={"flex-start"}>
      <HStack
        width="100%"
        spacing="15px"
        wrap="wrap"
        padding="0 20px"
        marginTop="20px"
        justify="center"
      >
        <FiltersGrid
          page="openProfit"
          renderButtons={(buttons) => buttons}
        />

          <TableData data={pageStore?.data_open_profit} renderButtons={(buttons) => buttons} />
      </HStack>
    </VStack>
  );
});

export default OpenProfitPage;
